import React from 'react'
import CardsRow from '../components/CardsRow/CardsRow'

const LastHourCharts: React.FC = () => {
    return (
        <div className="main-container">
            <span className="section-title">Top radio nell&apos;ultima ora</span>
            <CardsRow chartTimeSpan="last_hour" limit={12} />
        </div>
    )
}

export default LastHourCharts
